import * as React from "react";
const SvgElectricBolt = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 2 2.5 13 13 14l-5 7 1 1 12.5-11L11 10l5-7z",
  fill: "currentColor"
}));
export default SvgElectricBolt;